import { Component, OnInit, HostListener } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
// import { url } from 'inspector';
import { ElementRef } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";  
import { LoadingScreenComponent } from 'src/app/shared/loading-screen/loading-screen.component';
import { LoadingScreenService } from 'src/app/shared/loading-screen/loading-screen.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
contact:any;
lit:any;
list=[];
lit2:any;
list2=[];
tomken:any;
isLoggedin=false;
audioPlayerRef:any;
isVisible:boolean = false;
screen: boolean = true;


inputObj = "91";
constructor(private http: HttpClient, private router: Router, private SpinnerService: LoadingScreenService) { }

getNumber(event:any){
  // console.log(this.inputObj+this.contact )
}

onCountryChange(event:any){
  // console.log(event.dialCode+this.contact)
  this.inputObj = event.dialCode
}

@HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    console.log(scroll/100)
    $('.parallax-zoom img').css({
      width: `${150 - scroll / 2}%`,
      // top: `-${scroll / 10}%`
    });
        if(scroll<=225){
          $(".logo").css({
            "top": `${20+scroll/7}vh`,
          });
        }
    // else if(scroll>100){
    //   $(".logo").css({
    //     "transform": `1`,
    //     "top": `60vh`
    //   });
    // }
    if(scroll <= 500){
      $('.nav-home').css({
        background: 'transparent',
        // top: `-${scroll / 10}%`
      });
    }
    else{
      $('.nav-home').css({
        background: '#04070A',
        // top: `-${scroll / 10}%`
      });
    }
    // if(250 - scroll/2 <= 150){
    //   this.isVisible = true
    // }
    // else{
    //   this.isVisible = false
    // }
  }

ngOnInit(): void {
    // this.SpinnerService();  
    if( window.screen.width<768){
      this.screen=false;
    }
    this.tomken = localStorage.getItem("authToken")
    if(this.tomken.length!=0){
      this.isLoggedin = true
    }
    const headers = { Authorization: "Token " + localStorage.getItem("authToken") }
    // this.http.get('https://api3.ecell.in/eureka22/gallery1/')
    // .subscribe(Data => {
    //   this.lit=Data;
    //   this.list=this.lit.spons;
    //   // console.log(this.list)
    // });
    // this.http.get('https://api3.ecell.in/eureka22/gallery2/')
    // .subscribe(Data => {
    //   this.lit2=Data;
    //   this.list2=this.lit2.spons;
    //   // console.log(this.list)
    // });
  }
  logout(){
    localStorage.clear();
    window.location.reload();
  }
  check(){
    if(this.isLoggedin){
      this.router.navigate(['/db']);
    }
    else{
      this.router.navigate(['/login']);
    }
  }
  onregister(){
    this.isVisible = !this.isVisible
    if(this.isVisible==true){
      window.scrollTo(0,0)
    }
  }

// number count for stats, using jQuery animate


}
